export interface SentencesTable {
    sentence: string[];
    row_id: number[];
}

export const DEFAULT_SENTENCE_TABLE: SentencesTable = {
    sentence: [],
    row_id: [],
};
